// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"79989ded","137":"1cfa52f0","236":"d630186b","771":"f9ce850e","787":"723be057","804":"96b3fbc1"}[chunkId] + ".chunk.js";
};